export enum PayableActionType {
  ADD_ADJUSTMENT_FAILURE = '@@payable/ADD_ADJUSTMENT_FAILURE',
  ADD_ADJUSTMENT_REQUEST = '@@payable/ADD_ADJUSTMENT_REQUEST',
  ADD_ADJUSTMENT_SUCCESS = '@@payable/ADD_ADJUSTMENT_SUCCESS',

  CREATE_ONE_OFF_LEDGER_ITEM_FAILURE = '@@payable/CREATE_ONE_OFF_LEDGER_ITEM_FAILURE',
  CREATE_ONE_OFF_LEDGER_ITEM_REQUEST = '@@payable/CREATE_ONE_OFF_LEDGER_ITEM_REQUEST',
  CREATE_ONE_OFF_LEDGER_ITEM_SUCCESS = '@@payable/CREATE_ONE_OFF_LEDGER_ITEM_SUCCESS',

  DELETE_ADJUSTMENT_FAILURE = '@@payable/DELETE_ADJUSTMENT_FAILURE',
  DELETE_ADJUSTMENT_REQUEST = '@@payable/DELETE_ADJUSTMENT_REQUEST',
  DELETE_ADJUSTMENT_SUCCESS = '@@payable/DELETE_ADJUSTMENT_SUCCESS',

  DELETE_PAYABLE_FAILURE = '@@payable/DELETE_PAYABLE_FAILURE',
  DELETE_PAYABLE_REQUEST = '@@payable/DELETE_PAYABLE_REQUEST',
  DELETE_PAYABLE_SUCCESS = '@@payable/DELETE_PAYABLE_SUCCESS',

  GET_ADJUSTMENTS_BY_LEDGER_ITEM_ID_FAILURE = '@@payable/GET_ADJUSTMENTS_BY_LEDGER_ITEM_ID_FAILURE',
  GET_ADJUSTMENTS_BY_LEDGER_ITEM_ID_REQUEST = '@@payable/GET_ADJUSTMENTS_BY_LEDGER_ITEM_ID_REQUEST',
  GET_ADJUSTMENTS_BY_LEDGER_ITEM_ID_SUCCESS = '@@payable/GET_ADJUSTMENTS_BY_LEDGER_ITEM_ID_SUCCESS',

  GET_ALL_ADJUSTMENTS_FAILURE = '@@payable/GET_ALL_ADJUSTMENTS_FAILURE',
  GET_ALL_ADJUSTMENTS_REQUEST = '@@payable/GET_ALL_ADJUSTMENTS_REQUEST',
  GET_ALL_ADJUSTMENTS_SUCCESS = '@@payable/GET_ALL_ADJUSTMENTS_SUCCESS',

  GET_ALL_FAILURE = '@@payable/GET_ALL_FAILURE',
  GET_ALL_REQUEST = '@@payable/GET_ALL_REQUEST',
  GET_ALL_SUCCESS = '@@payable/GET_ALL_SUCCESS',

  GET_BY_ID_FAILURE = '@@payable/GET_BY_ID_FAILURE',
  GET_BY_ID_REQUEST = '@@payable/GET_BY_ID_REQUEST',
  GET_BY_ID_SUCCESS = '@@payable/GET_BY_ID_SUCCESS',

  GET_DETAIL_PAGE = '@@payable/GET_DETAIL_PAGE',

  GET_EVENTS_BY_ID_FAILURE = '@@payable/GET_EVENTS_BY_ID_FAILURE',
  GET_EVENTS_BY_ID_REQUEST = '@@payable/GET_EVENTS_BY_ID_REQUEST',
  GET_EVENTS_BY_ID_SUCCESS = '@@payable/GET_EVENTS_BY_ID_SUCCESS',

  IGNORE_PAYABLE_FAILURE = '@@payable/IGNORE_PAYABLE_FAILURE',
  IGNORE_PAYABLE_REQUEST = '@@payable/IGNORE_PAYABLE_REQUEST',
  IGNORE_PAYABLE_SUCCESS = '@@payable/IGNORE_PAYABLE_SUCCESS',

  REGENERATE_LEDGER_ITEMS_FAILURE = '@@payable/REGENERATE_LEDGER_ITEMS_FAILURE',
  REGENERATE_LEDGER_ITEMS_REQUEST = '@@payable/REGENERATE_LEDGER_ITEMS_REQUEST',
  REGENERATE_LEDGER_ITEMS_SUCCESS = '@@payable/REGENERATE_LEDGER_ITEMS_SUCCESS',

  SETTLE_LEDGER_ITEMS_FAILURE = '@@payable/SETTLE_LEDGER_ITEMS_FAILURE',
  SETTLE_LEDGER_ITEMS_REQUEST = '@@payable/SETTLE_LEDGER_ITEMS_REQUEST',
  SETTLE_LEDGER_ITEMS_SUCCESS = '@@payable/SETTLE_LEDGER_ITEMS_SUCCESS',

  TOGGLE_ADD_ADJUSTMENTS_FORM = '@@payable/TOGGLE_ADD_ADJUSTMENTS_FORM',
  TOGGLE_CREATE_ONE_OFF_LEDGER_ITEM = '@@payable/TOGGLE_CREATE_ONE_OFF_LEDGER_ITEM',
  UPDATE_ADD_ADJUSTMENTS_FORM = '@@payable/UPDATE_ADD_ADJUSTMENTS_FORM',
}
